(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  let cartBusy = false;

  function cartDrawer() {
    return document.getElementById('CartDrawer');
  }

  function openCart(immediate) {
    const el = cartDrawer();
    if (!el) return;
    el.hidden = false;
    if (immediate) {
      el.classList.add('no-animate', 'is-open');
      document.body.classList.add('cart-open');
      requestAnimationFrame(() => el.classList.remove('no-animate'));
      return;
    }
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.classList.add('is-open');
        document.body.classList.add('cart-open');
      });
    });
  }

  function closeCart() {
    const el = cartDrawer();
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    document.body.classList.remove('cart-open');
    const panel = el.querySelector('.cart-drawer__panel');
    let settled = false;
    const finish = () => {
      if (settled || el.classList.contains('is-open')) return;
      settled = true;
      el.hidden = true;
    };
    panel?.addEventListener('transitionend', finish, { once: true });
    window.setTimeout(finish, 480);
  }

  function formatMoney(cents) {
    const format = cartDrawer()?.dataset.moneyFormat || '';
    if (!format) return `£${(cents / 100).toFixed(2)}`;
    const amount = (cents / 100).toFixed(2);
    const noDecimals = String(Math.round(cents / 100));
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function showCartError(message) {
    const error = document.querySelector('[data-cart-error]');
    if (!error) return;
    error.hidden = !message;
    error.textContent = message || '';
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function applyCart(cart) {
    setCartCount(cart.item_count);
    const subtotal = document.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    const items = document.querySelector('.cart-drawer__items');
    if (!items) return false;
    if (cart.item_count === 0) return false;
    const seen = new Set(cart.items.map((item) => item.key));
    let complete = true;
    cart.items.forEach((item) => {
      const line = items.querySelector(`[data-line-key="${CSS.escape(item.key)}"]`);
      if (!line) {
        complete = false;
        return;
      }
      const input = line.querySelector('[data-qty-input]');
      if (input) {
        input.value = item.quantity;
        input.dataset.qtyCurrent = item.quantity;
      }
      const price = line.querySelector('[data-line-price]');
      if (price) price.textContent = formatMoney(item.final_line_price);
      line.classList.remove('is-updating');
      line.querySelectorAll('button, input').forEach((control) => {
        control.disabled = false;
      });
    });
    items.querySelectorAll('[data-line-key]').forEach((line) => {
      if (!seen.has(line.dataset.lineKey)) line.remove();
    });
    const foot = document.querySelector('.cart-drawer__foot');
    if (foot) foot.hidden = false;
    return complete;
  }

  function setLineUpdating(key, updating) {
    const line = document.querySelector(`[data-line-key="${CSS.escape(key)}"]`);
    if (!line) return null;
    line.classList.toggle('is-updating', updating);
    line.querySelectorAll('button, input').forEach((control) => {
      control.disabled = updating;
    });
    return line;
  }

  async function refreshCart(options) {
    const root = document.querySelector('[data-cart-root]');
    if (!root) return;
    const id = root.dataset.sectionId;
    const response = await fetch(`/?sections=${encodeURIComponent(id)}`);
    const payload = await response.json();
    const html = payload[id];
    if (!html) return;
    const wrap = document.createElement('div');
    wrap.innerHTML = html.trim();
    const next = wrap.querySelector('[data-cart-root]');
    if (!next) return;
    const nextItems = next.querySelector('.cart-drawer__items');
    const nextFoot = next.querySelector('.cart-drawer__foot');
    const panel = root.querySelector('.cart-drawer__panel');
    root.querySelector('.cart-drawer__items')?.replaceWith(nextItems);
    const foot = root.querySelector('.cart-drawer__foot');
    if (nextFoot) {
      if (foot) foot.replaceWith(nextFoot);
      else panel?.append(nextFoot);
    } else {
      foot?.remove();
    }
    const cart = await (await fetch('/cart.js')).json();
    setCartCount(cart.item_count);
    applyCart(cart);
    if (options.open && !root.classList.contains('is-open')) openCart(false);
    showCartError(options.error || '');
  }

  function fallbackError() {
    return document.querySelector('[data-cart-fallback]')?.textContent || '';
  }

  async function changeLine(key, quantity) {
    if (cartBusy) return;
    cartBusy = true;
    setLineUpdating(key, true);
    showCartError('');
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const error = data.description || data.message || fallbackError();
        showCartError(error);
        const cart = await (await fetch('/cart.js')).json();
        const updated = applyCart(cart);
        if (!updated) await refreshCart({ open: true, error });
        return;
      }
      const updated = applyCart(data);
      if (!updated) await refreshCart({ open: true });
    } finally {
      setLineUpdating(key, false);
      cartBusy = false;
    }
  }

  document.addEventListener('click', async (event) => {
    if (event.target.closest('[data-cart-open]')) {
      event.preventDefault();
      openCart(false);
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeCart();
      return;
    }
    const remove = event.target.closest('[data-qty="0"]');
    if (remove) {
      event.preventDefault();
      await changeLine(remove.dataset.qtyKey, 0);
      return;
    }
    const step = event.target.closest('[data-qty-step]');
    if (step) {
      event.preventDefault();
      const input = step.closest('.qty')?.querySelector('[data-qty-input]');
      if (!input) return;
      const next = Math.max(0, Number(input.value || 0) + Number(step.dataset.qtyStep));
      await changeLine(input.dataset.qtyKey, next);
    }
  });

  document.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-qty-input]');
    if (!input) return;
    const quantity = Number(input.value);
    if (!Number.isFinite(quantity) || quantity < 0) return;
    await changeLine(input.dataset.qtyKey, quantity);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCart();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-product-form]');
    if (!form) return;
    event.preventDefault();
    if (cartBusy) return;
    const button = form.querySelector('[type="submit"]');
    const formError = form.querySelector('[data-form-error]');
    if (formError) {
      formError.hidden = true;
      formError.textContent = '';
    }
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
    }
    cartBusy = true;
    const id = form.querySelector('[name="id"]').value;
    const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }] })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const error = data.description || data.message || fallbackError();
        if (formError) {
          formError.hidden = false;
          formError.textContent = error;
        }
        await refreshCart({ open: true, error });
        return;
      }
      await refreshCart({ open: true });
    } finally {
      cartBusy = false;
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('[data-header]');
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-nav-overlay]');
  const searchModal = document.querySelector('[data-search-modal]');
  const searchInput = document.querySelector('[data-search-input]');
  const searchResults = document.querySelector('[data-search-results]');
  let searchTimer = 0;
  let searchRequest = 0;

  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-solid', window.scrollY > 24);
  }

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  function openMenu() {
    if (!menu || !header) return;
    closeSearch(true);
    menu.hidden = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        menu.classList.add('is-open');
        header.classList.add('is-menu-open');
        document.body.classList.add('menu-open');
        toggle?.setAttribute('aria-expanded', 'true');
      });
    });
  }

  function closeMenu() {
    if (!menu || !header || !menu.classList.contains('is-open')) return;
    menu.classList.remove('is-open');
    header.classList.remove('is-menu-open');
    document.body.classList.remove('menu-open');
    toggle?.setAttribute('aria-expanded', 'false');
    const finish = () => {
      if (!menu.classList.contains('is-open')) menu.hidden = true;
    };
    menu.addEventListener('transitionend', finish, { once: true });
    window.setTimeout(finish, 500);
  }

  function openSearch() {
    if (!searchModal) return;
    closeMenu();
    searchModal.hidden = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        searchModal.classList.add('is-open');
        searchInput?.focus();
      });
    });
  }

  function closeSearch(immediate) {
    if (!searchModal || searchModal.hidden) return;
    searchModal.classList.remove('is-open');
    const finish = () => {
      if (!searchModal.classList.contains('is-open')) searchModal.hidden = true;
    };
    if (immediate) {
      finish();
      return;
    }
    searchModal.addEventListener('transitionend', finish, { once: true });
    window.setTimeout(finish, 420);
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
  }

  function priceLabel(product) {
    const price = product.price;
    if (typeof price === 'string' && price.trim()) {
      return /[£$€]/.test(price) ? price : `£${price}`;
    }
    if (typeof price === 'number') return `£${(price / 100).toFixed(2)}`;
    return '';
  }

  async function runSearch(query) {
    if (!searchResults) return;
    const term = query.trim();
    if (term.length < 2) {
      searchResults.innerHTML = '';
      return;
    }
    const requestId = ++searchRequest;
    searchResults.innerHTML = `<p class="search-modal__status">${escapeHtml(searchResults.dataset.searching || 'Searching…')}</p>`;
    const endpoint = searchModal.dataset.predictiveUrl || '/search/suggest';
    const url = `${endpoint}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      const data = await response.json();
      if (requestId !== searchRequest) return;
      const products = data?.resources?.results?.products || [];
      if (!products.length) {
        searchResults.innerHTML = `<p class="search-modal__status">${escapeHtml(searchResults.dataset.empty || 'No products found.')}</p>`;
        return;
      }
      searchResults.innerHTML = products.map((product) => {
        const image = product.image || product.featured_image?.url || '';
        const imageHtml = image ? `<img src="${escapeHtml(image)}" alt="">` : '<span></span>';
        return `<a class="search-hit" href="${escapeHtml(product.url)}">${imageHtml}<span>${escapeHtml(product.title)}</span><small>${escapeHtml(priceLabel(product))}</small></a>`;
      }).join('');
    } catch (error) {
      if (requestId !== searchRequest) return;
      searchResults.innerHTML = '';
    }
  }

  toggle?.addEventListener('click', () => {
    if (menu?.classList.contains('is-open')) closeMenu();
    else openMenu();
  });

  menu?.addEventListener('click', (event) => {
    if (event.target.closest('a')) closeMenu();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-search-open]')) {
      event.preventDefault();
      openSearch();
      return;
    }
    if (event.target.closest('[data-search-close]')) {
      event.preventDefault();
      closeSearch(false);
    }
  });

  searchInput?.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(() => runSearch(searchInput.value), 180);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMenu();
    closeSearch(false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('[data-scroll-next]')?.addEventListener('click', () => {
    document.querySelector('.marquee')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const filters = document.querySelector('[data-shop-filters]');
  const backdrop = document.querySelector('[data-filters-backdrop]');

  function syncSortFields() {
    const narrow = window.matchMedia('(max-width: 700px)').matches;
    document.querySelectorAll('[data-sort-keep]').forEach((field) => {
      field.disabled = narrow;
    });
    document.querySelectorAll('[data-sort-drawer]').forEach((field) => {
      field.disabled = !narrow;
    });
  }

  syncSortFields();
  window.addEventListener('resize', syncSortFields);

  function openFilters() {
    if (window.matchMedia('(min-width: 900px)').matches || !filters) return;
    if (backdrop) backdrop.hidden = false;
    document.body.classList.add('filters-open');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        filters.classList.add('is-open');
        backdrop?.classList.add('is-open');
      });
    });
  }

  function closeFilters() {
    if (!filters || !filters.classList.contains('is-open')) return;
    filters.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
    document.body.classList.remove('filters-open');
    const finish = () => {
      if (filters.classList.contains('is-open') || !backdrop) return;
      backdrop.hidden = true;
    };
    filters.addEventListener('transitionend', finish, { once: true });
    window.setTimeout(finish, 450);
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-filters-open]')) openFilters();
    if (event.target.closest('[data-filters-close]')) closeFilters();
  });

  document.addEventListener('change', (event) => {
    const field = event.target.closest('[data-sort-bar], [data-shop-filters] select, [data-shop-filters] input[type="checkbox"]');
    if (!field || !field.form) return;
    if (typeof field.form.requestSubmit === 'function') field.form.requestSubmit();
    else field.form.submit();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeFilters();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const modal = document.querySelector('[data-pickup-modal]');
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('pickup-open');
    window.setTimeout(() => {
      if (!modal.classList.contains('is-open')) modal.hidden = true;
    }, 420);
  });

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-tab]');
    if (!tab) return;
    const root = tab.closest('.product-tabs');
    root.querySelectorAll('[data-tab]').forEach((button) => {
      const selected = button === tab;
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    root.querySelectorAll('[data-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.panel !== tab.dataset.tab;
    });
  });

  document.addEventListener('click', (event) => {
    const modal = document.querySelector('[data-pickup-modal]');
    if (!modal) return;
    if (event.target.closest('[data-pickup-open]')) {
      modal.hidden = false;
      document.body.classList.add('pickup-open');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => modal.classList.add('is-open'));
      });
      return;
    }
    if (event.target.closest('[data-pickup-close]')) {
      modal.classList.remove('is-open');
      document.body.classList.remove('pickup-open');
      window.setTimeout(() => {
        if (!modal.classList.contains('is-open')) modal.hidden = true;
      }, 420);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
